import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';

import Table from '../Table';
import palette from '../../styles/palette';
import SliderCard from '../../SliderCard';
import { Text } from '../../Base';

const useTableStyles = makeStyles(() => ({
  headerCell: {
    background: palette.stopListHeader,
  },
  bodyCell: {
    height: '1px',
  },
  footerCell: {
    border: 'none',
  },
}));

const useStyles = makeStyles(({ typography }) => ({
  subTitle: {
    fontSize: typography.pxToRem(14),
    letterSpacing: '-0.02rem',
    textTransform: 'capitalize',
    color: palette.typography.black.medium,
    marginBottom: typography.pxToRem(20),
  },
}));

const ModalTable = ({ title, subTitle, columns, data }) => {
  const classes = useTableStyles();
  const styles = useStyles();

  return (
    <SliderCard title={title}>
      {subTitle && <Text className={styles.subTitle}>{subTitle}</Text>}
      <Table columns={columns} data={data} classes={classes} isParcelDetails />
    </SliderCard>
  );
};

export default memo(ModalTable);
